export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "British",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "Spain",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "Mandarin",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_catalog_label: "",
    nav_primary_catalog_select_language_label: "",
    nav_primary_contact_label: "",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "你有问题吗？ 打电话给我们",
    nav_primary_phone_number: "Beijing (+86 10 5634 1576)",
    nav_primary_sign_in_label: "",
    nav_primary_support_label: "",
    nav_primary_switch_language: "",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "高等教育",
    nav_primary_vertical_education_secondary_label: "培训中心",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "企业",
    nav_primary_vertical_for_young_learners_label: "",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "主页",
    nav_secondary_enterprise_label: "企业",
    nav_secondary_enterprise_resources_label: "资源",
    nav_secondary_enterprise_solutions_label: "语言解决方案",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "主页",
    nav_secondary_education_primary_label: "高等教育",
    nav_secondary_education_primary_resources_label: "资源",
    nav_secondary_education_primary_solutions_label: "语言解决方案",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_home_label: "主页",
    nav_secondary_education_secondary_label: "培训中心",
    nav_secondary_education_secondary_resources_label: "资源",
    nav_secondary_education_secondary_solutions_label: "语言解决方案",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "受到顶级组织信任超过25年",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "人们对我们的评价.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;“基于计算机的语言学习的<em>黄金标准。</em>&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;“我喜欢Rosetta Stone的软件，<em>我认为他们学习语言的方法很有效。</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;“凭借其出色的用户界面，清晰的指令，各种各样的游戏和挑战......<em>Rosetta Stone提供了这么多。</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "",
    related_resources_button_label: "",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "你是什​​么类型的学习者？",
    verticals_education_primary: "高等教育",
    verticals_education_secondary: "培训中心",
    verticals_enterprise: "企业",
    verticals_publicsector: "",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "国家",
    footer_cta_form_email: "电子邮箱（学校）",
    footer_cta_form_firstname: "名",
    footer_cta_form_lastname: "姓",
    footer_cta_form_organization: "企业／机构名称",
    footer_cta_form_organizationsize: "组织规模",
    footer_cta_form_organizationsize_100: "100或更少",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001  - 更多",
    footer_cta_form_phone: "电话 （可选的）",
    footer_cta_form_pricing_thanks: "感谢您对Rosetta Stone的关注！ 有人会尽快与您联系并提供有用的信息。",
    footer_cta_form_role: "角色（或头衔）",
    footer_cta_form_role_boardmember: "董事会成员",
    footer_cta_form_role_curriculumdirector: "课程总监/指导协调员",
    footer_cta_form_role_director: "主管",
    footer_cta_form_role_executive: "经理",
    footer_cta_form_role_individualcontributor: "独立工作员工",
    footer_cta_form_role_manager: "总经理",
    footer_cta_form_role_principal: "校长",
    footer_cta_form_role_superintendent: "学监/区行政长官",
    footer_cta_form_role_teacher: "老师",
    footer_cta_form_role_techcoordinator: "技术协调员",
    footer_cta_form_role_vicepresident: "副总裁",
    footer_cta_form_submit: "免费咨询",
    footer_cta_how_hear_blog: "",
    footer_cta_how_hear_email: "电子邮件",
    footer_cta_how_hear_event: "事件",
    footer_cta_how_hear_online: "线上",
    footer_cta_how_hear_other: "其他",
    footer_cta_how_hear_referral: "推荐",
    footer_cta_how_hear_search: "搜索引擎",
    footer_cta_how_hear_social: "社交媒体",
    footer_cta_how_hear_title: "您是怎么知道我们的？ （可选的）",
    footer_cta_how_hear_webinar: "网络研讨会",
    footer_cta_opt_in_learn_more_button_text: "更多信息在這裡。",
    footer_cta_opt_in_learn_more_link_text_1: "隐私政策",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://www.rosettastone.com/privacy",
    footer_cta_opt_in_learn_more_text_1:
        "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: "。",
    footer_cta_opt_in_text_after_button: "",
    footer_cta_opt_in_text_before_button: "是! 我想收到Rosetta Stone的产品更新和营销。",
    footer_cta_pricing_button: "价格 ",
    footer_cta_pricing_label: "准备好下一步了吗？",
    footer_cta_pricing_subtitle: "请完成，我们会立即与您联系。",
    footer_cta_pricing_title: "了解您所需要的价格信息。",

    // Menu
    footer_menu_about_careers_label: "职业发展",
    footer_menu_about_contact_label: "联系我们",
    footer_menu_about_investors_label: "投资者关系",
    footer_menu_about_label: "关于我们",
    footer_menu_about_press_label: "新闻",
    footer_menu_products_consumer_label: "从哪里开始？",
    footer_menu_products_education_primary_label: "高等教育",
    footer_menu_products_education_secondary_label: "培训中心",
    footer_menu_products_enterprise_label: "企业",
    footer_menu_products_label: "从哪里开始？",
    footer_menu_support_label: "支持",
    footer_menu_support_support_site_label: "支持網站",

    // Meta
    footer_meta_agreements_label: "协议",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie设置",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label:
        "1999-2021 Rosetta Stone Ltd.保留所有权利。 本网站使用cookies。 继续使用本网站即表示同意使用cookie。",
    footer_meta_icp_label: "京ICP备09009396号-7",
    footer_meta_icp_link: "https://beian.miit.gov.cn",
    footer_meta_privacy_policy_label: "隐私政策",
    footer_meta_terms_conditions_label: "条款和条件",

    // Region
    footer_region_label: "变更地区",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Conecte-se conosco",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
